import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import DialogContent from '@mui/material/DialogContent';

export default function AlertDialog(props) {
  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{props.message}</DialogTitle>
        {(props.activeContent)
          ? (
            <DialogContent>
              <DialogContentText>
                {props.text}
              </DialogContentText>
            </DialogContent>
          )
          : <></>}
        <DialogActions style={{ padding: '.5rem 1.5rem 1.5rem 0rem' }}>
          <Button
            onClick={() => props.positiveCall()}
            style={{
              backgroundColor: '#0267C1',
              color: 'white',
            }}
          >
            {props.button}
          </Button>
          {!props.noCancel && (
            <Button
              onClick={() => props.setOpen(false)}
              style={{
                border: '1px solid red',
                color: 'red',
              }}
            >
              Cancelar
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
